import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://zums.edu.bd";
const DEFAULT_IMAGE = `${BASE_URL}/src/assets/favIcon.png`;

const STATIC_ROUTE_META = {
  "/": {
    title: "ZNRF University of Management Sciences (ZUMS) - Future Leaders",
    description:
      "Explore ZUMS academic programs, admissions, research, and campus life at ZNRF University of Management Sciences.",
    keywords:
      "ZUMS, ZNRF University, university in Bangladesh, higher education, admissions, academics, research",
  },
  "/admission": {
    title: "Admissions | ZUMS",
    description:
      "Apply to ZUMS and review admission requirements, process, key dates, and student support opportunities.",
    keywords: "ZUMS admission, university admission, apply to ZUMS, admission requirements",
  },
  "/admission/tuition-fees": {
    title: "Tuition Fees | ZUMS Admission",
    description:
      "Review ZUMS tuition fees and academic cost details for prospective students and guardians.",
    keywords: "ZUMS tuition fees, university fee structure, admission fees",
  },
  "/admission/scholarship": {
    title: "Scholarships | ZUMS Admission",
    description:
      "Discover ZUMS scholarships, eligibility criteria, and financial aid options for qualified students.",
    keywords: "ZUMS scholarship, financial aid, university scholarship",
  },
  "/life-at-zums": {
    title: "Life At ZUMS | Campus Experience",
    description:
      "See student life, clubs, events, and the vibrant campus environment at ZUMS.",
    keywords: "ZUMS campus life, student life, university events",
  },
  "/academics": {
    title: "Academics | ZUMS",
    description:
      "Explore ZUMS schools, departments, course offerings, and academic resources.",
    keywords: "ZUMS academics, schools, departments, academic programs",
  },
  "/academics/zums-incubation-center": {
    title: "ZUMS Incubation Center | Academics",
    description:
      "Learn how the ZUMS Incubation Center supports innovation, entrepreneurship, and student ventures.",
    keywords: "ZUMS incubation center, innovation, entrepreneurship",
  },
  "/academics/academic-calendar": {
    title: "Academic Calendar | ZUMS",
    description:
      "View the official ZUMS academic calendar, including semester schedules and important dates.",
    keywords: "ZUMS academic calendar, semester dates, university calendar",
  },
  "/academics/research2": {
    title: "Research | ZUMS",
    description:
      "Explore research priorities, initiatives, and knowledge development at ZUMS.",
    keywords: "ZUMS research, academic research, innovation",
  },
  "/academics/research3": {
    title: "Research Programs | ZUMS",
    description:
      "Discover advanced research programs, outputs, and academic collaboration opportunities at ZUMS.",
    keywords: "ZUMS research programs, university research initiatives",
  },
  "/academics/zums-technology-innovation-lab": {
    title: "Technology Innovation Lab | ZUMS",
    description:
      "Explore the ZUMS Technology Innovation Lab for practical learning, experimentation, and development.",
    keywords: "ZUMS lab, technology innovation lab, practical learning",
  },
  "/academics/course-catalog": {
    title: "Course Catalog | ZUMS",
    description:
      "Browse the ZUMS course catalog to review available courses and academic pathways.",
    keywords: "ZUMS course catalog, university courses, curriculum",
  },
  "/centers-of-excellence/iqac": {
    title: "IQAC | Center Of Excellence | ZUMS",
    description:
      "Learn about the IQAC center at ZUMS and its quality assurance and academic enhancement activities.",
    keywords: "ZUMS IQAC, quality assurance, center of excellence",
  },
  "/centers-of-excellence/edrc": {
    title: "EDRC | Center Of Excellence | ZUMS",
    description:
      "Explore EDRC at ZUMS and its contributions to development research and policy insight.",
    keywords: "ZUMS EDRC, development research, center of excellence",
  },
  "/centers-of-excellence/clll": {
    title: "CLLL | Center Of Excellence | ZUMS",
    description:
      "Discover CLLL at ZUMS and its role in lifelong learning and academic advancement.",
    keywords: "ZUMS CLLL, lifelong learning, center of excellence",
  },
  "/library": {
    title: "Library | ZUMS",
    description:
      "Access ZUMS library resources, services, and learning support facilities.",
    keywords: "ZUMS library, academic resources, student learning",
  },
  "/grading-system": {
    title: "Grading System | ZUMS",
    description:
      "Understand the official ZUMS grading system, evaluation method, and academic performance standards.",
    keywords: "ZUMS grading system, GPA, evaluation",
  },
  "/discover-zums/ambition-commitment-values": {
    title: "Ambition, Commitment And Values | Discover ZUMS",
    description:
      "Learn about ZUMS ambition, commitment, and institutional values that shape student outcomes.",
    keywords: "ZUMS values, mission, vision, commitment",
  },
  "/discover-zums/why-choose-zums": {
    title: "Why Choose ZUMS | Discover ZUMS",
    description:
      "See why students choose ZUMS for quality academics, practical learning, and career-ready education.",
    keywords: "why choose ZUMS, ZUMS benefits, university choice",
  },
  "/discover-zums/board-of-trustees": {
    title: "Board Of Trustees | ZUMS",
    description:
      "Meet the ZUMS Board of Trustees and learn about institutional governance and leadership direction.",
    keywords: "ZUMS board of trustees, governance, leadership",
  },
  "/discover-zums/office-of-the-vc": {
    title: "Office Of The VC | ZUMS",
    description:
      "Read leadership vision and institutional priorities from the Office of the Vice Chancellor at ZUMS.",
    keywords: "ZUMS vice chancellor, office of VC, university leadership",
  },
  "/discover-zums/advisory-board": {
    title: "Advisory Board | ZUMS",
    description:
      "Learn about the ZUMS Advisory Board and how it supports strategy, growth, and quality education.",
    keywords: "ZUMS advisory board, university strategy, academic leadership",
  },
  "/discover-zums/faculty": {
    title: "Faculty | Discover ZUMS",
    description:
      "Meet experienced ZUMS faculty members committed to quality teaching, mentorship, and research.",
    keywords: "ZUMS faculty, university teachers, academic staff",
  },
  "/discover-zums/administration": {
    title: "Administration | Discover ZUMS",
    description:
      "Explore ZUMS administration, operational leadership, and student-focused institutional services.",
    keywords: "ZUMS administration, university management",
  },
  "/info": {
    title: "Information Center | ZUMS",
    description:
      "Get notices, announcements, and important updates from the ZUMS Information Center.",
    keywords: "ZUMS information center, university notice, announcements",
  },
  "/career": {
    title: "Career Opportunities | ZUMS",
    description:
      "Explore career opportunities and recruitment information at ZUMS.",
    keywords: "ZUMS career, university jobs, employment opportunities",
  },
  "/news-and-events": {
    title: "News And Events | ZUMS",
    description:
      "Stay updated with latest ZUMS news, events, and important campus activities.",
    keywords: "ZUMS news, university events, campus updates",
  },
  "/terms-and-condition": {
    title: "Terms And Conditions | ZUMS",
    description:
      "Read ZUMS terms and conditions, policies, and legal information.",
    keywords: "ZUMS terms, conditions, policies",
  },
  "/zums-voices": {
    title: "ZUMS Voices | Student Stories",
    description:
      "Read student and community voices, stories, and testimonials from ZUMS.",
    keywords: "ZUMS voices, student testimonials, university stories",
  },
  "/alumni": {
    title: "Alumni | ZUMS",
    description:
      "Connect with the ZUMS alumni network and explore graduate achievements and engagement.",
    keywords: "ZUMS alumni, graduate network, alumni success",
  },
};

const DYNAMIC_ROUTE_META = [
  {
    pattern: /^\/academics\/[^/]+$/,
    meta: {
      title: "Academic School Details | ZUMS",
      description:
        "Explore school-level academic information, curriculum highlights, and opportunities at ZUMS.",
      keywords: "ZUMS school, academics, university programs",
    },
  },
  {
    pattern: /^\/academics\/department\/[^/]+$/,
    meta: {
      title: "Department Details | ZUMS Academics",
      description:
        "Review department-level curriculum, faculty, and opportunities in ZUMS academics.",
      keywords: "ZUMS department, academics, faculty",
    },
  },
  {
    pattern: /^\/discover-zums\/faculty\/[^/]+$/,
    meta: {
      title: "Faculty Profile | ZUMS",
      description:
        "View detailed ZUMS faculty profile information including teaching and research background.",
      keywords: "ZUMS faculty profile, academic expert",
    },
  },
  {
    pattern: /^\/life-at-zums\/[^/]+$/,
    meta: {
      title: "Life At ZUMS Details | Campus Experience",
      description:
        "Explore detailed student life stories, activities, and experiences from ZUMS campus life.",
      keywords: "ZUMS life details, campus activities",
    },
  },
];

const FALLBACK_META = {
  title: "404 - Page Not Found | ZUMS",
  description: "The page you requested could not be found on ZUMS.",
  keywords: "ZUMS 404, page not found",
};

const normalizePath = (path) => {
  if (!path) return "/";
  const clean = path.split("?")[0].split("#")[0];
  if (clean.length > 1 && clean.endsWith("/")) {
    return clean.slice(0, -1);
  }
  if (clean.toLowerCase() === "/academics/academic-calendar") {
    return "/academics/academic-calendar";
  }
  if (clean === "/academics/academic-Calendar") {
    return "/academics/academic-calendar";
  }
  return clean;
};

const titleFromPath = (path) =>
  path
    .split("/")
    .filter(Boolean)
    .map((segment) => segment.replace(/-/g, " "))
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(" > ");

export default function RouteSeo() {
  const { pathname } = useLocation();
  const normalizedPath = normalizePath(pathname);

  const staticMeta = STATIC_ROUTE_META[normalizedPath];
  const dynamicMeta = DYNAMIC_ROUTE_META.find(({ pattern }) =>
    pattern.test(normalizedPath)
  )?.meta;
  const isKnownRoute = Boolean(staticMeta || dynamicMeta);

  const meta = staticMeta || dynamicMeta || FALLBACK_META;
  const canonicalUrl = `${BASE_URL}${normalizedPath === "/" ? "" : normalizedPath}`;
  const pageName = normalizedPath === "/" ? "Home" : titleFromPath(normalizedPath);

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: meta.title,
    description: meta.description,
    url: canonicalUrl,
    inLanguage: "en",
    isPartOf: {
      "@type": "WebSite",
      name: "ZNRF University of Management Sciences (ZUMS)",
      url: BASE_URL,
    },
    about: {
      "@type": "CollegeOrUniversity",
      name: "ZNRF University of Management Sciences (ZUMS)",
      url: BASE_URL,
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: BASE_URL,
      },
      ...(normalizedPath === "/"
        ? []
        : [
            {
              "@type": "ListItem",
              position: 2,
              name: pageName,
              item: canonicalUrl,
            },
          ]),
    ],
  };

  return (
    <Helmet prioritizeSeoTags>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <meta
        name="robots"
        content={
          isKnownRoute
            ? "index, follow, max-image-preview:large"
            : "noindex, follow, noarchive"
        }
      />
      <meta
        name="googlebot"
        content={
          isKnownRoute
            ? "index, follow, max-image-preview:large"
            : "noindex, follow, noarchive"
        }
      />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ZUMS" />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={DEFAULT_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />

      <script type="application/ld+json">
        {JSON.stringify([webPageSchema, breadcrumbSchema])}
      </script>
    </Helmet>
  );
}
